export default __webpack_public_path__ + "static/media/redux-logo.296b9306.png";